import keyMirror from 'keymirror';
import _ from 'lodash';
import shortid from 'shortid';
import moment from 'moment';
import { SECONDS_IN_HOURS } from '../../services/Constants';

export const groupDetailsActionTypes = keyMirror({
	GET_GROUP_DETAILS_REQUEST: null,
	GET_GROUP_DETAILS_SUCCESS: null,
	GET_GROUP_DETAILS_ERROR: null,

	GET_GROUP_LISTS_REQUEST: null,
	GET_GROUP_LISTS_SUCCESS: null,
	GET_GROUP_LISTS_ERROR: null,

	TOGGLE_GROUP_ADD_LIST_MODAL: null,
	GROUP_ADD_ITEMS_REQUEST: null,
	GROUP_ADD_ITEMS_SUCCESS: null,
	GROUP_ADD_ITEMS_ERROR: null,

	GET_GROUP_MEMBERS_REQUEST: null,
	GET_GROUP_MEMBERS_SUCCESS: null,
	GET_GROUP_MEMBERS_ERROR: null,
	CLEAN_MEMBERS_STATE: null,

	DELETE_USER_FROM_GROUP_REQUEST: null,
	DELETE_USER_FROM_GROUP_SUCCESS: null,
	DELETE_USER_FROM_GROUP_ERROR: null,

	DELETE_LIST_FROM_GROUP_REQUEST: null,
	DELETE_LIST_FROM_GROUP_SUCCESS: null,
	DELETE_LIST_FROM_GROUP_ERROR: null,

	ACCEPT_USER_REQUEST: null,
	ACCEPT_USER_SUCCESS: null,
	ACCEPT_USER_ERROR: null,

	DECLINE_USER_REQUEST: null,
	DECLINE_USER_SUCCESS: null,
	DECLINE_USER_ERROR: null,

	REVOKE_USER_INVITE_REQUEST: null,
	REVOKE_USER_INVITE_SUCCESS: null,
	REVOKE_USER_INVITE_ERROR: null,

	CHECK_IF_USER_EXIST_REQUEST: null,
	CHECK_IF_USER_EXIST_SUCCESS: null,
	CHECK_IF_USER_EXIST_ERROR: null,

	SET_VALID_INVITE_MEMBERS: null,
	TOGGLE_GROUP_INVITE_MODAL: null,

	INVITE_USERS_REQUEST: null,
	INVITE_USERS_SUCCESS: null,
	INVITE_USERS_ERROR: null,

	CLEAR_INVITE_USERS_FORM: null,

	GET_GROUP_LIST_MEMBERS_REQUEST: null,
	GET_GROUP_LIST_MEMBERS_SUCCESS: null,
	GET_GROUP_LIST_MEMBERS_ERROR: null,

	GET_GROUP_LIST_RESULTS_REQUEST: null,
	GET_GROUP_LIST_RESULTS_SUCCESS: null,
	GET_GROUP_LIST_RESULTS_ERROR: null,

	CLEAR_GROUP_DETAILS: null,

	GET_GROUP_MEMBER_LISTS_REQUEST: null,
	GET_GROUP_MEMBER_LISTS_SUCCESS: null,
	GET_GROUP_MEMBER_LISTS_ERROR: null,

	CLEAN_GROUP_CONTENT_STATE: null,

	GET_DIFFICULT_WORDS_REQUEST: null,
	GET_DIFFICULT_WORDS_SUCCESS: null,
	GET_DIFFICULT_WORDS_ERROR: null,

	GET_GROUP_QUESTIONS: null,
	GET_GROUP_QUESTIONS_SUCCESS: null,
	GET_GROUP_QUESTIONS_ERROR: null,

	GET_GROUP_QUESTION_ANSWERS: null,
	GET_GROUP_QUESTION_ANSWERS_SUCCESS: null,
	GET_GROUP_QUESTION_ANSWERS_ERROR: null,

	GET_INSTITUTE_LICENCES: null,
	GET_INSTITUTE_LICENCES_SUCCESS: null,
	GET_INSTITUTE_LICENCES_ERROR: null,
	ADD_LICENCES_TO_GROUP: null,
	ADD_LICENCES_TO_GROUP_FINAL: null,
	REMOVE_INACTIVE_LICENSE: null,
	REMOVE_INACTIVE_LICENSE_SUCCESS: null,

	PROMOTE_GROUP_USER_TO_MANAGER: null,
	PROMOTE_GROUP_USER_TO_MANAGER_FINAL: null,
});

export const getGroupSortingOptions = (t) => [
	{ title: t('group_details.sorting_options.added'), key: 'added_on_timestamp' },
	{
		title: t('group_details.sorting_options.last_practiced'),
		key: 'last_practiced_timestamp',
	},
	{ title: t('group_details.sorting_options.alphabetical'), key: 'alphabetical' },
	{ title: t('group_details.sorting_options.language'), key: 'language' },
];

export const getGroupTabs = (t) => [
	{ title: t('group_details.tabs.exercises'), value: 'exercises', id: 0 },
	{ title: t('group_details.tabs.members'), value: 'members', id: 1 },
	{ title: t('group_details.tabs.results'), value: 'results/per-lists', id: 2 },
	{ title: t('group_details.results_toggle.per_exercises'), value: 'per-exercises', id: 2 },
	{ title: t('group_details.results_toggle.per_members'), value: 'per-members', id: 2 },
];

export const groupByStatus = (users, orderField = 'id') => {
	const order = orderField === 'id' ? 'desc' : 'asc';

	return (
		users &&
		!!users.length &&
		_(users)
			.groupBy((prop) => prop.status)
			.map((group) => _.orderBy(group, [(prop) => prop[orderField]], order))
			.map((group) => ({ title: group[0].status, group }))
			.value()
	);
};

export const getUsers = (users, status) => {
	if (users) {
		const filteredUsers = users.filter((user) => user.title === status)[0];
		return (filteredUsers && filteredUsers.group) || filteredUsers || null;
	}
	return false;
};

export const getMembersOrderOptions = (t) => [
	{ title: t('group_details.activity_order_options.first_name'), key: 'first_name' },
	{ title: t('group_details.activity_order_options.last_name'), key: 'last_name' },
	{ title: t('group_details.activity_order_options.last_added'), key: 'id' },
];

export const getInfoByStatus = (t, status, institute, params, groupOwner) => {
	const { name: instituteName } = institute || {};
	if (status === 'invited_by_group_owner')
		return t(`group_details.empty_state.invited.${params}`, { groupOwner });
	if (status === 'requested_to_join') return t(`group_details.empty_state.requested.${params}`);
	return t(`group_details.empty_state.default.${params}${instituteName ? '_institute' : ''}`, {
		instituteName,
	});
};

export const groupBySections = (lists) => {
	return (
		!!lists.length &&
		_(lists)
			.map((item) => ({ ...item }))
			.groupBy((prop) => prop.added_on_category)
			.map((group) => ({
				id: shortid.generate(),
				title: group[0].added_on_category,
				group,
			}))
			.value()
	);
};

export const getListCardResultTabs = (t) => [
	{ title: t('group_details.list_card_results_menu.results'), value: 'results', index: 0 },
	{ title: t('group_details.list_card_results_menu.words'), value: 'words', index: 1 },
	{
		title: t('group_details.list_card_results_menu.questions'),
		value: 'questions',
		index: 1,
	},
];

export const formatTime = (seconds) => {
	return moment()
		.startOf('day')
		.seconds(seconds)
		.format(seconds >= SECONDS_IN_HOURS ? 'hh:mm:ss' : 'mm:ss');
};

export const getResultsLinkName = (type) => {
	switch (type) {
		case 'list':
			return 'exercise-results';
		case 'topic':
			return 'topic-results';
		case 'chapter':
			return 'chapter-results';
		case 'user_quiz':
			return 'quiz-results';
		default:
			return '';
	}
};

export const getGroupQuery = (type, groupId) =>
	`${type === 'chapter' ? '/results' : ''}?groupId=${groupId}`;
